import { DirectoryWithIcon } from './directoryWithIcon'
import { Document } from './document'
import { Node, NodeType } from './treenode'

export type DirectoryChildren = Directory<any> | Document
export type DocumentChildType = DirectoryChildren | DirectoryWithIcon

export class Directory<ChildType extends DocumentChildType> extends Node<
    ChildType[]
> {
    private _content: ChildType[] = []

    readonly type = 'directory' as NodeType

    addChild(child: ChildType) {
        this._content = [...this._content, child]
        child.parent = this
        return this
    }

    get content(): ChildType[] {
        return [...this._content]
    }
}
